import React, { useState } from 'react';

import CloseRequestDialog from './CloseRequestDialog';
import FixedBottomCTA from '../FixedBottomCTA';
import RfqDetail from '@routes/Common/RfqDetail';
import RightSideHeader from '../RightSideHeader';

import {
  CapaRfqStatus,
  FetchQuotationUserRfqDetailQuery
} from '@generated/graphql';

interface Props {
  matches: boolean;
  rfqInfo?: FetchQuotationUserRfqDetailQuery;
  rfqInfoRefetch: () => void;
  onChangePath: (_path: string, callback?: () => void) => void;
}

const MyRequestDetailContainer: React.FC<Props> = ({
  matches,
  rfqInfo,
  rfqInfoRefetch,
  onChangePath
}) => {
  const [dialog, setDialog] = useState({
    closeRequest: false
  });

  const requestClosedStatus = [
    CapaRfqStatus.Expired,
    CapaRfqStatus.ExpiredByClient,
    CapaRfqStatus.Stopped
  ].includes(
    rfqInfo?.fetchQuotationUserRfqDetail.data?.status as CapaRfqStatus
  );

  return (
    <React.Fragment>
      <RightSideHeader
        onPrevious={() => {
          onChangePath('/dashboard');
        }}
        label={rfqInfo?.fetchQuotationUserRfqDetail.data?.projectName ?? ''}
      />

      {dialog.closeRequest && (
        <CloseRequestDialog
          matches={matches}
          rfqId={rfqInfo?.fetchQuotationUserRfqDetail.data?.id ?? ''}
          open={true}
          requestClosedStatus={requestClosedStatus}
          onClose={() => {
            setDialog({ closeRequest: false });
          }}
          rfqInfoRefetch={rfqInfoRefetch}
        />
      )}
      <FixedBottomCTA
        matches={matches}
        buttons={[
          {
            disabled: requestClosedStatus,
            action: () => {
              setDialog({ closeRequest: true });
            },
            label: '견적비교 마감하기'
          }
        ]}
      >
        <RfqDetail
          rfqId={rfqInfo?.fetchQuotationUserRfqDetail.data?.id ?? ''}
          matches={matches}
        />
      </FixedBottomCTA>
    </React.Fragment>
  );
};

export default MyRequestDetailContainer;
